import { createEstabelecimentoApi } from "@/contexts/cadastro/estabelecimento/api/estabelecimentoApi";
import { Estabelecimento } from "@/contexts/cadastro/estabelecimento/model/Estabelecimento";
import { TIPO_INSPECAO } from "@/contexts/cadastro/estabelecimento/model/TIPO_INSPECAO";
import {
  estabelecimentoAction,
  getEstabelecimentosSynced,
} from "@/contexts/cadastro/estabelecimento/store/estabelecimentoSlice";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useEstabelecimento = () => {
  const { user } = useAuth();
  const estabelecimentoApi = createEstabelecimentoApi(user?.access_token);
  const listaEstabelecimentos = useSelector(getEstabelecimentosSynced);
  const appDispatch = useDispatch();
  const { sync } = estabelecimentoAction;

  const estabelecimentoOptions = listaEstabelecimentos.map((e) => ({
    label: `${e.numeroInspecao} - ${TIPO_INSPECAO[e.tipoInspecao]} - ${e.nome}`,
    value: e.id,
  }));

  const getEstabelecimentosApi = estabelecimentoApi.listAll;

  const sincronizarEstabelecimentos = (estabelecimentos: Estabelecimento[]) => {
    appDispatch(sync(estabelecimentos));
  };

  const getEstabelecimentoById = (id: number) => {
    return listaEstabelecimentos.find(
      (estabelecimento) => estabelecimento.id === id
    );
  };

  return {
    getEstabelecimentosApi,
    listaEstabelecimentos,
    sincronizarEstabelecimentos,
    estabelecimentoOptions,
    getEstabelecimentoById,
  };
};
